import qs from 'qs';
import { get } from 'lodash';
const extoleKeys = ['advocate_code', 'labels'];

export const getReferrerDetails = (search: qs.ParsedQs | undefined): string | undefined => {
  if (!search) return undefined;

  const extoleParams: Record<string, string> = {};

  extoleKeys.forEach(key => {
    if (search[key] !== undefined) {
      extoleParams[key] = get(search, key, '') as string;
    }
  })

  return Object.keys(extoleParams).length > 0 ?
    new URLSearchParams(extoleParams).toString() :
    undefined;
}